import Vue from 'vue'
import VueRouter from 'vue-router'

//Pages
import Home from '../views/Home.vue'

//About
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import CFS from '../views/CallForSubmission.vue'

import Sublanding from '../components/Landing/Sublanding.vue'

//Writing
import Writing from '../views/Writing/Writing.vue'
import Hafsa from '../components/Writing/Poetry/Hafsa_Zulfiqar/Content.vue'
import Valeria from '../components/Writing/Poetry/Valeria_Sibrian_Quijada/Content.vue'
import Michalina from '../components/Writing/Poetry/Michalina_Aniol/Content.vue'
import Zanna from '../components/Writing/Poetry/Zanna_Huth/Content.vue'
import Domenica from '../components/Writing/Poetry/Domenica_Montano/Content.vue'
import Soumya from '../components/Writing/Prose/Soumya_Rachel_Shailendra/Content.vue'
import Juan from '../components/Writing/Prose/Juan_Lopez/Content.vue'

//Visual Arts
import VA from '../views/VA/VA.vue'
import Alyssa from '../components/VA/Video/AlyssaPong/Content.vue'
import Kale from '../components/VA/PDS/Kale_Esposito/Content.vue'
import Reshavan from '../components/VA/Photography/Reshavan_Naiker/Content.vue'
import Jonathan from '../components/VA/Video/Jonathan_Lee/Content.vue'
import Melih from '../components/VA/PDS/Melih_Meric/Content.vue'
import Ayesha from '../components/VA/Video/Ayesha_Bashir/Content.vue'
import Xiao from '../components/VA/Photography/Xiao_Ma/Content.vue'

//Performing Arts
import PA from '../views/PA/PA.vue'
import Andreea from '../components/PA/Podcast/Andreea_Coscai/Content.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/call-for-submission',
    name: 'CFS',
    component: CFS
  }
  ,
  {
    path: '/writing/:subcategories',
    name: 'Writing',
    component: Writing,
    props: true
  }
  ,
  {
    path: '/writing/poetry/:pageTitle/:articleList',
    name: 'Poetry',
    component: Sublanding,
    props: true
  },
  {
    path: '/writing/poetry/the-one-who-was-named-before-his-birth',
    name: 'the-one-who-was-named-before-his-birth',
    component: Hafsa,
    props: true
  },
  {
    path: '/writing/poetry/hermanos-lejanos',
    name: 'hermanos-lejanos',
    component: Valeria,
    props: true
  },
  {
    path: '/writing/poetry/warsaw',
    name: 'warsaw',
    component: Michalina,
    props: true
  },
  {
    path: '/writing/poetry/one-language-is-never-enough',
    name: 'one-language-is-never-enough',
    component: Zanna,
    props: true
  },
  {
    path: '/writing/poetry/the-troubling-journey-of-a-name-in-the-u-s',
    name: 'the-troubling-journey-of-a-name-in-the-u-s',
    component: Domenica,
    props: true
  },
  {
    path: '/writing/prose',
    name: 'Prose',
    component: Sublanding,
    props: true
  },
  {
    path: '/writing/prose/an-elegy-for-my-mothers-tongue',
    name: 'an-elegy-for-my-mothers-tongue',
    component: Soumya,
    props: true
  },
  {
    path: '/writing/prose/a-documentation-of-youth',
    name: 'a-documentation-of-youth',
    component: Juan,
    props: true
  },
  {
    path: '/visual-arts',
    name: 'VA',
    component: VA,
    props: true
  }
  ,
  {
    path: '/visual-arts/video/:articleList',
    name: 'Video',
    component: Sublanding,
    props: true
  },
  {
    path: '/visual-arts/video/i-dont-know-what-to-say',
    name: 'i-dont-know-what-to-say',
    component: Alyssa,
    props: true
  },
  {
    path: '/visual-arts/video/how-to-make-kimchi-or-how-to-be-korean',
    name: 'how-to-make-kimchi-or-how-to-be-korean',
    component: Jonathan,
    props: true
  },
  {
    path: '/visual-arts/video/0-28',
    name: '0-28',
    component: Ayesha,
    props: true
  },
  {
    path: '/visual-arts/film',
    name: 'Film',
    component: CFS
  },
  {
    path: '/visual-arts/photography',
    name: 'Photography',
    component: Sublanding,
    props: true
  },
  {
    path: '/visual-arts/photography/the-price-of-being-captured',
    name: 'the-price-of-being-captured',
    component: Reshavan,
    props: true
  },
  {
    path: '/visual-arts/photography/the-only-virus-present-is-your-racism ',
    name: 'the-only-virus-present-is-your-racism',
    component: Xiao,
    props: true
  },
  {
    path: '/visual-arts/animation',
    name: 'Animation',
    component: CFS
  },
  {
    path: '/visual-arts/paiting-drawing-sculptures',
    name: 'PDS',
    component: Sublanding,
    props: true
  },
  {
    path: '/visual-arts/paiting-drawing-sculptures/4-yellow-windows',
    name: '4-yellow-windows',
    component: Kale,
    props: true
  },
  {
    path: '/visual-arts/paiting-drawing-sculptures/3-printmaking-pieces',
    name: '3-printmaking-pieces',
    component: Melih,
    props: true
  },
  {
    path: '/performing-arts',
    name: 'PA',
    component: PA,
    props: true
  }
  ,
  {
    path: '/performing-arts/music',
    name: 'Music',
    component: CFS
  },
  {
    path: '/performing-arts/scripts',
    name: 'Scripts',
    component: CFS
  },
  {
    path: '/performing-arts/dance',
    name: 'Dance',
    component: CFS
  },
  {
    path: '/performing-arts/drama',
    name: 'Drama',
    component: CFS
  },
  {
    path: '/performing-arts/podcast',
    name: 'Podcast',
    component: Sublanding,
    props: true
  },
  {
    path: '/performing-arts/podcast/whose-choice-is-my-choice',
    name: 'whose-choice-is-my-choice',
    component: Andreea,
    props: true
  },
  { path: "*", component: CFS },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
